import { TrialPeriod } from "@/components";
import { useUIStore } from "@/stores";
import { UserRole } from "@/types";
import {
  Box,
  Button,
  Divider,
  FormControlLabel,
  Stack,
  Switch,
  TextField,
} from "@mui/material";
import { FC, FormEvent, useState } from "react";
import { useApproveUser } from "../../queries";
import { ApproveUserProps } from "./approve-user.types";

const ApproveUser: FC<ApproveUserProps> = ({ userId, userRole }) => {
  const { closeModal } = useUIStore();
  const { approveUser, isApproveUserLoading } = useApproveUser();

  const [vettingNote, setVettingNote] = useState("");
  const [showTrialSettings, setShowTrialSettings] = useState(false);
  const [trialSettings, setTrialSettings] = useState<{
    endDate?: string;
    infinite?: boolean;
  }>({
    endDate: undefined,
    infinite: false,
  });

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    approveUser({
      userId,
      vettingNote: vettingNote.length ? vettingNote : undefined,
      freeTrialEndDate: trialSettings.endDate,
      hasInfiniteFreeTrial: trialSettings.infinite,
    });
  };

  return (
    <Box component="form" onSubmit={onSubmit}>
      {userRole === UserRole.ALPHA && (
        <FormControlLabel
          control={
            <Switch
              value={!showTrialSettings}
              onChange={() => setShowTrialSettings(!showTrialSettings)}
            />
          }
          labelPlacement="start"
          label="Trial"
          sx={{ width: "100%", justifyContent: "space-between", marginLeft: 0 }}
        />
      )}
      <TextField
        multiline
        label="Vetting note"
        slotProps={{ htmlInput: { maxLength: 500 } }}
        minRows={5}
        value={vettingNote}
        onChange={({ target: { value } }) => setVettingNote(value)}
      />

      {showTrialSettings && (
        <Stack>
          <Divider sx={{ margin: "8px 0" }}>Trial period</Divider>

          <TrialPeriod
            onChange={(newEndDate, isInfinite) =>
              setTrialSettings({ endDate: newEndDate, infinite: isInfinite })
            }
          />
        </Stack>
      )}

      <Stack direction={"row"} spacing={2} mt={2}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          disabled={isApproveUserLoading}
          onClick={closeModal}
        >
          Cancel
        </Button>
        <Button
          fullWidth
          variant="contained"
          color="secondary"
          type="submit"
          loading={isApproveUserLoading}
          disabled={isApproveUserLoading}
        >
          Approve
        </Button>
      </Stack>
    </Box>
  );
};

export { ApproveUser };
